/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserStreakResponse } from './UserStreakResponse';
import {
    UserStreakResponseFromJSON,
    UserStreakResponseFromJSONTyped,
    UserStreakResponseToJSON,
    UserStreakResponseToJSONTyped,
} from './UserStreakResponse';
import type { StreakConfigResponse } from './StreakConfigResponse';
import {
    StreakConfigResponseFromJSON,
    StreakConfigResponseFromJSONTyped,
    StreakConfigResponseToJSON,
    StreakConfigResponseToJSONTyped,
} from './StreakConfigResponse';
import type { PlatformStreakLeaderboardEntry } from './PlatformStreakLeaderboardEntry';
import {
    PlatformStreakLeaderboardEntryFromJSON,
    PlatformStreakLeaderboardEntryFromJSONTyped,
    PlatformStreakLeaderboardEntryToJSON,
    PlatformStreakLeaderboardEntryToJSONTyped,
} from './PlatformStreakLeaderboardEntry';

/**
 * 
 * @export
 * @interface StreakChallengeDetailResponse
 */
export interface StreakChallengeDetailResponse {
    /**
     * 
     * @type {StreakConfigResponse}
     * @memberof StreakChallengeDetailResponse
     */
    config: StreakConfigResponse;
    /**
     * 
     * @type {number}
     * @memberof StreakChallengeDetailResponse
     */
    participantCount: number;
    /**
     * 
     * @type {UserStreakResponse}
     * @memberof StreakChallengeDetailResponse
     */
    userStreak?: UserStreakResponse;
    /**
     * 
     * @type {number}
     * @memberof StreakChallengeDetailResponse
     */
    userRank?: number;
    /**
     * 
     * @type {Array<PlatformStreakLeaderboardEntry>}
     * @memberof StreakChallengeDetailResponse
     */
    topEntries: Array<PlatformStreakLeaderboardEntry>;
}

/**
 * Check if a given object implements the StreakChallengeDetailResponse interface.
 */
export function instanceOfStreakChallengeDetailResponse(value: object): value is StreakChallengeDetailResponse {
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('participantCount' in value) || value['participantCount'] === undefined) return false;
    if (!('topEntries' in value) || value['topEntries'] === undefined) return false;
    return true;
}

export function StreakChallengeDetailResponseFromJSON(json: any): StreakChallengeDetailResponse {
    return StreakChallengeDetailResponseFromJSONTyped(json, false);
}

export function StreakChallengeDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakChallengeDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'config': StreakConfigResponseFromJSON(json['config']),
        'participantCount': json['participantCount'],
        'userStreak': json['userStreak'] == null ? undefined : UserStreakResponseFromJSON(json['userStreak']),
        'userRank': json['userRank'] == null ? undefined : json['userRank'],
        'topEntries': ((json['topEntries'] as Array<any>).map(PlatformStreakLeaderboardEntryFromJSON)),
    };
}

export function StreakChallengeDetailResponseToJSON(json: any): StreakChallengeDetailResponse {
    return StreakChallengeDetailResponseToJSONTyped(json, false);
}

export function StreakChallengeDetailResponseToJSONTyped(value?: StreakChallengeDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'config': StreakConfigResponseToJSON(value['config']),
        'participantCount': value['participantCount'],
        'userStreak': UserStreakResponseToJSON(value['userStreak']),
        'userRank': value['userRank'],
        'topEntries': ((value['topEntries'] as Array<any>).map(PlatformStreakLeaderboardEntryToJSON)),
    };
}

